import type { SpinResponse } from "@slot/client-engine";
import { MergeRoundBuilder } from "../../MergeRoundBuilder";
import { OFFLINE_ROUND } from "../offlineRound";

/**
 * Up the ladder to the scatter in one spin, right of the board's centre: a 2×2 L1 merges into two L2 on its lower row,
 * and the two L2 stacked above it fall beside them — a 2×2 L2, which makes two L3, which meet the two L3 falling next;
 * from L4 on, the next pair drops in from above the grid. L1 → L2 → L3 → L4 → H1, and the H1 cluster merges into one
 * FS. The four badges grow with every win (x2 to x6), so each cluster pays more than the last: 0.20, 2.40 (×8), 4.80
 * (×12), 8.00 (×16), 16.00 (×20) — 31.40, the big tier.
 */
export function mergeChain(): SpinResponse {
  return new MergeRoundBuilder({ roundId: "merge-chain", ...OFFLINE_ROUND })
    .baseSpin({
      board: [
        ["L2", "L4", "H2", "L3", "L3", "L1"],
        ["L3", "H1", "L1", "L2", "L2", "H3"],
        ["L1", "L2", "H4", "L1", "L1", "H2"],
        ["L4", "L3", "H3", "L1", "L1", "H4"],
        ["H1", "L1", "L2", "H2", "H3", "L3"],
        ["L2", "L4", "L1", "L4", "L2", "L2"],
      ],
      refill: [[], [], [], ["L4", "H1", "L2", "L4", "L1"], ["L4", "H1", "L1", "L3", "L2", "H4"], []],
    })
    .build();
}
